import React from 'react';

import { PageTitle, ErrorBoundary } from '@cordata/buffet';

import Form from '~/components/TermsOfUse/form';

const TermsOfUse = () => (
  <ErrorBoundary>
    <PageTitle>Terms of Use</PageTitle>

    <Form layout="card" />
  </ErrorBoundary>
);

export default TermsOfUse;
